package pt.at.oss.kotlin.manual.storage.common.currvatid

import kotlinx.serialization.Serializable
import pt.lightweightform.kotlin.storage.BaseRecord

/**
 * CurrVatId Serializable object
 *
 * NOTE FOR DEVELOPERS:
 *  - This file was generated. Any modifications to this file will be lost after generation
 * @generated
 */
@Serializable
data class CurrVatId(
    var issuingCountry: String = "",
    var vatIdNum: String = ""
) : BaseRecord()
